import {
  eachDayOfInterval,
  eachHourOfInterval,
  endOfDay,
  endOfMonth,
  startOfDay,
  startOfMonth,
} from 'date-fns';
import {match} from 'ts-pattern';

import type {RentalCalendarScale} from '../types/RentalCalendarScale';
import type {RentalCalendarView} from '../types/RentalCalendarView';

/**
 * Derives the timeline geometry for the selected view and date. The month view renders one
 * column per day, the day view one column per hour — everything else about the calendar
 * (rows, event bars, collisions) is scale-agnostic.
 */
export function getCalendarScale(view: RentalCalendarView, date: Date): RentalCalendarScale {
  return match<RentalCalendarView, RentalCalendarScale>(view)
    .with('month', () => {
      const rangeStart = startOfMonth(date);
      const rangeEnd = endOfMonth(date);

      return {
        view,
        rangeStart,
        rangeEnd,
        columns: eachDayOfInterval({start: rangeStart, end: rangeEnd}),
      };
    })
    .with('day', () => {
      const rangeStart = startOfDay(date);
      const rangeEnd = endOfDay(date);

      return {
        view,
        rangeStart,
        rangeEnd,
        columns: eachHourOfInterval({start: rangeStart, end: rangeEnd}),
      };
    })
    .exhaustive();
}
